import { useId } from 'react';
import classNames from 'classnames';
import NextImage from 'next/image';
import Heading from 'components/atoms/heading/Heading';
import type { CampaignDownloadProps } from './Campaign.data';
import styles from './Campaign.module.scss';

export default function CampaignDownload({
  id,
  title,
  image,
  children,
  className,
}: CampaignDownloadProps) {
  const headingId = useId();
  return (
    <section
      id={id}
      tabIndex={-1}
      aria-labelledby={headingId}
      className={classNames(styles.download, className)}
    >
      <Heading
        as="h2"
        id={headingId}
        size="heading-03"
        className={styles.downloadTitle}
        transitionInType="none"
        disableTriggerInOnScroll
      >
        {title}
      </Heading>
      <div className={classNames(styles.downloadGrid, { [styles.withCover]: !!image?.src })}>
        {image?.src ? (
          <div className={styles.reportCover}>
            <NextImage
              {...image}
              alt={image.alt}
              className={styles.reportImage}
              sizes="(min-width: 1024px) 46vw, 92vw"
            />
          </div>
        ) : null}
        <div className={styles.formPanel}>{children}</div>
      </div>
    </section>
  );
}
